// Selección de variantes al hover
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('hover-variant-btn')) {
    const btn = e.target;
    const card = btn.closest('.card-hover-actions');
    card.querySelectorAll('.hover-variant-btn').forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');
    const input = card.querySelector('.hover-selected-variant');
    if (input) input.value = btn.dataset.variantId;
  }
});

document.addEventListener('submit', function(e) {
  const form = e.target;
  if (!form.closest('.card-hover-actions')) return;

  e.preventDefault();

  const variantId = form.querySelector('[name="id"]').value;
  const submitBtn = form.querySelector('[type="submit"]');
  submitBtn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(res => res.json())
  .then((itemData) => {
    return fetch('/cart?view=ajax', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(res => res.text())
    .then(() => {
      // Usar el endpoint de secciones directamente
      return fetch(`/?section_id=cart-drawer`);
    })
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const cartDrawer = document.querySelector('cart-drawer');
      const newDrawerInner = doc.querySelector('.drawer__inner');
      
      if (cartDrawer && newDrawerInner) {
        cartDrawer.querySelector('.drawer__inner').innerHTML = newDrawerInner.innerHTML;
        cartDrawer.classList.remove('is-empty');
        setTimeout(() => {
          cartDrawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', cartDrawer.close.bind(cartDrawer));
          cartDrawer.open();
        }, 50);
      }
    });
  })
  .catch(err => console.error('Error:', err))
  .finally(() => { submitBtn.disabled = false; });
});

/*ocultar controles del video*/
